import {useContext} from "react";
import {CIAMAuthContext} from "../context";

import {CIAMContextType} from "../types";

export const  useCIAMAuth  = () => {
    const context: CIAMContextType = useContext(CIAMAuthContext);
    const {ciamSession , logOut, loadChallenge, reverseSso, config, tag} = context;
    return {ciamSession , logOut, loadChallenge, reverseSso, config, tag };
}
